import React, { useState } from "react";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";
import { ReactComponent as Uploading } from "../../assets/images/icons/uploading.svg";
import { ReactComponent as Push } from "../../assets/images/icons/PushTask.svg";
import { ReactComponent as FileIcon_docx } from "../../assets/images/icons/FileIcon_docx.svg";
import { ReactComponent as CrossIconCreateGroup } from "../../assets/images/CrossIconCreateGroup.svg";
import { Field } from "formik";
import { pushAlert } from "../../utils/alertSlice";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { useDispatch } from "react-redux";
import CircularLoader from "../UniversalComponents/CircularLoader";

const AttachmentSubDrawer = ({
  selectedFiles,
  setSelectedFiles,
  handleFileUpload = () => {},
  handleDeleteFileServer = () => {},
  AttachmentLoading,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const downloadFile = async (file) => {
    const url = `${file}`;

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <div className="w-full h-full bg-white p-2">
        <div className="flex w-full">
          <MotionSearchBox
            placeholder="Search..."
            isSearchActive={isExpanded}
            setIsSearchActive={setIsExpanded}
            searchText={searchTerm}
            setSearchText={setSearchTerm}
            expanded
          />
        </div>
        <div className="w-full min-h-0 grow flex flex-col items-start justify-centr gap-y-4">
          <div className="w-full items-center justify-center gap-y-2">
            <div className="flex items-centre justify-centre gap-x-2 my-4 text-[#66666699]">
              <span className="text-sm">Attachment(0)</span>
              <span className="text-xs">Maximum Size 20 MB</span>
            </div>
            <div className="w-full border border-dashed flex flex-col items-center justify-center gap-y-2 p-3">
              <Uploading />
              <p className="text-[10px]">Drop files here or click to select from the device</p>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  handleFileUpload();
                }}
                className="flex items-center justify-center gap-x-1 border rounded-md px-2 py-1 text-xs"
              >
                Upload from this device
                <Push />
              </button>
            </div>
          </div>
          <div className="w-full min-h-0 grow h-full">{AttachmentLoading && <CircularLoader />}</div>

          {selectedFiles?.length > 0 && (
            <div className="w-full min-h-0 grow">
              <span className="text-sm font-600">Uploaded Files</span>
              <div className="flex flex-col items-start justify-center py-2 gap-y-4 w-full">
                {selectedFiles
                  ?.filter((item) => item?.file_name?.toLowerCase().includes(searchTerm.toLowerCase()))
                  .map((file, index) => (
                    <div key={index} className="group flex items-center justify-between w-full h-7 px-2 py-1">
                      <div className="flex items-center gap-x-2 min-w-0 ">
                        <FileIcon_docx />

                        <span className="text-sm truncate min-w-0">{file?.file_name}</span>
                      </div>

                      <div className="hidden group-hover:flex items-center justify-end gap-x-3">
                        <button
                          className="text-blue-500 hover:text-blue-700"
                          onClick={() => downloadFile(file?.view_url)}
                        >
                          <i className="bi bi-eye text-14"></i>
                        </button>

                        <button
                          className="text-blue-500 hover:text-blue-700"
                          onClick={() => downloadFile(file?.download_url)}
                        >
                          <i className="bi bi-download text-12"></i>
                        </button>

                        <CrossIconCreateGroup
                          className="cursor-pointer"
                          onClick={() => handleDeleteFileServer(file?.id)}
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AttachmentSubDrawer;
